import { cn } from "../lib/utils"

const BadgeVariants = {
  primary: "bg-brand text-white",
  "primary-outline": "bg-transparent border border-brand text-brand",
  secondary: "bg-brandSecondary text-white",
  "secondary-outline": "bg-transparent border border-brandSecondary text-brandSecondary",
  success: "text-green-500 border border-green-500 bg-white",
  locked: "bg-gray-100 text-gray-400",
  waiting: "text-yellow-400 border border-yellow-400 bg-white",
  error: "text-red-500 border border-red-500 bg-white",
}

export const Badge = ({ text, variant = "primary", width = "w-fit", className }) => (
  <div
    className={cn(
      "mx-auto my-auto flex h-fit w-fit flex-row items-center justify-start gap-1 rounded-full px-2 py-0.5 text-xs font-bold",
      BadgeVariants[variant],
      width,
      className
    )}
  >
    {variant === "success" && <i className="fa-solid fa-circle-check"></i>}
    {variant === "locked" && <i className="fa-solid fa-lock"></i>}
    {variant === "waiting" && <i className="fa-regular fa-clock"></i>}
    <div className={"w-full text-center"}>{text}</div>
  </div>
)
